import React from 'react';
import { useGetStarted } from './GetStartedContext';
import Card from './Card';

const Content: React.FC = () => {
  const { formdata, template, themeManager } = useGetStarted();

  return (
    <div
      className="gs-cards-container"
      style={themeManager.getCardStyles(template).container}
    >
      {formdata.map((item, index) => (
        <Card
          key={index}
          data={item}
          index={index}
          isLast={index === formdata.length - 1}
        />
      ))}
    </div>
  );
};

export default Content;
